<template>
  <div>
    <div>
      <div class="card-header">
        <div class="row">
          <div class="col-md-11">
            <h4>Gestión de deducciones en avanza</h4>
            <p>
              Aquí podrá gestionar la información relacionada con las
              <span class="text-success">deducciones</span> de los empleados de
              <span class="text-success">Avanza</span>
            </p>
          </div>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-md-4">
          <button @click="prepararRegistrar()" class="btn btn-secondary btn-fill" style="border-radius: 5px">
            Registrar deducción
          </button>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-md-3">
          <label for="fechaInicial">Fecha inicial:</label>
          <input
            type="date"
            class="form-control"
            v-model="fechaInicial"
            id="fechaIncial"
          />
        </div>
        <div class="col-md-3">
          <label for="fechaFinal">Fecha inicial:</label>
          <input
            type="date"
            class="form-control"
            v-model="fechaFinal"
            id="fechaFinal"
          />
        </div>
        <div class="col-md-3">
          <label for="acciones" style="display: none">Acciones</label><br />
          <button
            class="btn btn-success btn-fill"
            style="border-radius: 5px"
            @click="obtenerInformacionDescargos(fechaInicial, fechaFinal)"
          >
            Buscar información
          </button>
        </div>
      </div>
      <br />
      <div class="card">
        <div class="row" v-if="queriedData2 == ''">
          <center>
            <div class="col-md-12">
              <center>
                <img
                  src="/static/img/ICONOS/estadisticas.svg"
                  alt="Imagen de datos vacios"
                  width="70"
                />
                <p class="titulo-mensaje">Aún no hay datos para mostrar.</p>
              </center>
            </div>
          </center>
        </div>

        <div class="row" style="padding-left: 15px" v-if="queriedData2 != ''">
          <div class="col-3">
            <el-select
              class="select-default"
              v-model="pagination.perPage"
              placeholder="Per page"
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <br>
            <el-table
                border
                :data="queriedData"
                class="table-responsive table-striped mt-2"
              >
                <el-table-column
                  v-for="column in tableColumns"
                  :key="column.label"
                  :min-width="column.minWidth"
                  :prop="column.prop"
                  :label="column.label"
                >
                <template slot-scope="{ row }">
                  <div :class="getClass(column, row)" class="full-width">
                    <strong v-if="getClass(column, row) != ''">{{
                      formatearPesosColombianos(row[column.prop])
                    }}</strong>
                    <span v-else>{{ row[column.prop] }}</span>
                  </div>
                </template>
                </el-table-column>

                <el-table-column>
                  <template slot-scope="props">
                    <center>
                      <button
                        class="btn btn-simple btn-danger btn-icon like"
                        @click="deleteDiscart(props.row)"
                      >
                        <i class="ti-trash"></i>
                      </button>
                    </center>
                  </template>
                </el-table-column>
              </el-table>
          </div>
        </div>

        <modal
          name="registrar-descarte"
          :scrollable="true"
          height="auto"
          :reset="true"
        >
          <div class="modal-header" style="padding: 8px">
            <div class="row">
              <div class="col-md-12">
                <strong class="titulo-modal"> REGISTRAR UN DESCARGO </strong>
                <br />
                <span style="color: grey"> Asignación de descartes </span>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <form @submit.prevent="newDiscard()">
              <div class="row">
                <div class="col-md-12">
                  <label for="terapeuta">Terapeuta:</label>
                  <select name="terapeuta" id="terapeuta" required class="form-control" v-model="terapeuta">
                    <option value="">seleccione...</option>
                    <option :value="usuario.id" v-for="usuario in arrayTerapeutas" :key="usuario.id">
                        {{ usuario.nombres }} {{ usuario.apellidos }}
                    </option>
                  </select>
                </div>
                <div class="col-md-12">
                    <label for="valor">Valor del descarte:</label>
                    <input type="number" required class="form-control" v-model="valor">
                </div>
                <div class="col-md-12">
                  <label for="concepto">Seleccione el concepto:</label>
                  <select name="concepto" id="concepto" class="form-control" required v-model="concepto">
                    <option value="Informe atrasado">
                      Entrega de informe atrasado
                    </option>
                    <option value="Objetivos y logros">
                      Calificación de objetivos y logros
                    </option>
                  </select>
                </div>
                <div class="col-md-12">
                  <label for="nota">Nota (opcional):</label>
                  <textarea
                    v-model="nota"
                    name="nota"
                    id="nota"
                    cols="30"
                    rows="2"
                    class="form-control"
                  ></textarea>
                </div>
                <div class="col-md-12">
                  <center>
                    <br />
                    <button class="btn btn-secondary" @click="cerrarModal()">
                      Cancelar
                    </button>
                    <button type="submit" class="btn btn-success btn-fill">
                        Registrar descarte
                    </button>
                  </center>
                </div>
              </div>
            </form>
          </div>
        </modal>
      </div>
    </div>
  </div>
</template>
<script>
import axiosInstance from "src/global-services/axiosInstance";
import Vue from "vue";
import { Table, TableColumn, Select, Option } from "element-ui";
import PPagination from "src/components/UIComponents/Pagination.vue";
import JsonExcel from "vue-json-excel";
import crearAlerta from "../../global-services/crearAlerta";
import formatearPesosColombianos from "../../global-services/formatear-pesos";

Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);
Vue.component("downloadExcel", JsonExcel);

export default {
  computed: {
    pagedData() {
      return this.queriedData2.slice(this.from, this.to);
    },
    queriedData() {
      if (!this.searchQuery) {
        this.pagination.total = this.queriedData2.length;
        return this.pagedData;
      }
      let result = this.queriedData2.filter((row) => {
        let isIncluded = false;
        for (let key of this.propsToSearch) {
          let rowValue = row[key].toString().toLowerCase();
          if (
            rowValue.includes &&
            rowValue.includes(this.searchQuery.toLowerCase())
          ) {
            isIncluded = true;
          }
        }
        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      this.pagination.total = this.queriedData2.length;
      return this.queriedData2.length;
    },
  },
  data: () => ({
    searchQuery: "",
    fechaInicial: "",
    fechaFinal: "",
    concepto: 'Informe atrasado',
    nota: '',
    terapeuta: '',
    valor: '',
    queriedData2: [],
    arrayTerapeutas: [],
    fechaActual: "",
    tableColumns: [
      {
        prop: "terapeuta", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Usuario", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 180, //ANCHO DE LA COLUMNA
      },
      {
        prop: "fecha", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Fecha", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 180, //ANCHO DE LA COLUMNA
      },
      {
        prop: "valor", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Monto", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 100, //ANCHO DE LA COLUMNA
      },
      {
        prop: "concepto", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Concepto", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 100, //ANCHO DE LA COLUMNA
      },
      {
        prop: "nota", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Notas", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 100, //ANCHO DE LA COLUMNA
      }
    ],
    json_fields: {
      Usuario: "nombreUsuario",
      "Tipo de contrato": "tipoContrato",
      "Salario fijo": "salarioFijo",
      "Pago por sesión": "pagoPorSesion",
      "Pago por sesión domicilio": "pagoPorSesionDomicilio",
    },
    json_data: [],
    json_meta: [
      [
        {
          key: "charset",
          value: "utf-8",
        },
      ],
    ],
    sede: "Sede Principal",
    pagination: {
      perPage: 25,
      currentPage: 1,
      perPageOptions: [5, 10, 25, 50, 100, 200, 300],
      total: 0,
    },
  }),
  components: {
    PPagination,
  },
  methods: {
    formatearPesosColombianos,
    cerrarModal: function(){
        this.concepto = 'Informe atrasado';
        this.terapeuta = '';
        this.nota = '';
        this.valor = '';
        this.$modal.hide('registrar-descarte');
    },
    prepararRegistrar: function(){
        this.concepto = 'Informe atrasado';
        this.terapeuta = '';
        this.nota = '';
        this.valor = '';
        this.$modal.show('registrar-descarte');
    },
    selectTerapeuta: function (especialidad) {
      this.$modal.show("carga");
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      const BASE_URL = `api/selectTerapeutasProgramar/${especialidad}`;
      axiosInstance
        .get(BASE_URL, config)
        .then((res) => {
          this.$modal.hide("carga");
          this.arrayTerapeutas = res.data.data;
        })
        .catch((err) => {
          this.$modal.hide("carga");
          console.log(err);
        });
    },
    newDiscard: async function(){
        if(this.valor == '' || this.terapeuta == ''){
            this.$notify(
            crearAlerta(
                "danger",
                "Complete los campos requeridos"
            )
            );
            return;
        }
        try{
            this.$modal.show("carga");
            const data = {
                terapeuta: this.terapeuta,
                valor: this.valor,
                concepto: this.concepto,
                nota: this.nota,
                fecha: this.calcularFechaActual()
            };
            const response = await axiosInstance.post(
            'api/newDiscard', data
            );

            if(response.data.status === true){
                this.$notify(crearAlerta('success', response.data.mensaje));
                const fecha = this.calcularFechaActual();
                this.fechaInicial = fecha;
                this.fechaFinal = fecha;
                this.obtenerInformacionDescargos(fecha, fecha);
            }else{
                this.$notify(crearAlerta('danger', response.data.mensaje));
            }
        }catch(error) {
            this.$notify(crearAlerta('danger', error));
        }finally{
            this.$modal.hide("carga");
            this.cerrarModal();
        }
    },
    async obtenerInformacionDescargos(fechaInicial, fechaFinal) {
      if (fechaInicial == "" || fechaFinal == "") {
        this.$notify(
          crearAlerta(
            "danger",
            "Seleccione las fechas en las que quiere ver la información"
          )
        );
        return;
      }

      try {
        this.$modal.show("carga");
        const sede = localStorage.getItem("sede");
        const response = await axiosInstance.get(
          `api/informe-descartes/${fechaInicial}/${fechaFinal}/${sede}`
        );
        this.queriedData2 = response.data.data;
        this.json_data = response.data.data;
      } catch (error) {
        this.$notify(crearAlerta('danger', error));
      } finally {
        this.$modal.hide("carga");
      }
    },
    deleteDiscart: async function(descarte){
        try{
            this.$modal.show("carga");
            const data = { id: descarte.id };
            const response = await axiosInstance.post(
            `api/deleteDiscard`, data
            );

            if(response.data.status === true){
                this.$notify(crearAlerta('success', response.data.mensaje));
                const fecha = this.calcularFechaActual();
                this.fechaInicial = fecha;
                this.fechaFinal = fecha;
                this.obtenerInformacionDescargos(fecha, fecha);
            }else{
                this.$notify(crearAlerta('danger', response.data.mensaje));
            }
        } catch (error) {
            this.$notify(crearAlerta('danger', error));
        } finally {
            this.$modal.hide("carga");
        }
    },
    getClass(column, row) {
      if (column.prop === "valor") {
        return "low-percentage";
      }
      return "";
    },
    calcularFechaActual() {
      var fecha_hoy = new Date();

      var ahora_ano = fecha_hoy.getFullYear();
      var ahora_mes = fecha_hoy.getMonth() + 1;
      var ahora_dia = fecha_hoy.getDate();

      if (ahora_mes < 10 || ahora_dia < 10) {
        if (ahora_mes < 10) {
          ahora_mes = "0" + ahora_mes;
        }
        if (ahora_dia < 10) {
          ahora_dia = "0" + ahora_dia;
        }
        return ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      } else {
        return ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      }
    },
  },
  
  mounted() {
    this.rol = localStorage.getItem("rol");
    if (localStorage.getItem("rol") != 1) {
      this.sede = localStorage.getItem("sede");
    }
    const fechaInicial = this.calcularFechaActual();
    this.fechaInicial = fechaInicial;
    this.fechaFinal = fechaInicial;
    document.title = "Avanti | Gestión de descargos";
    this.selectTerapeuta(1);
    this.obtenerInformacionDescargos(fechaInicial, fechaInicial);
  },
};
</script>
  
  <style>
.card {
  box-shadow: 0 0 0 0;
  border-radius: 15px;
  padding: 2%;
}

.btn {
  border-radius: 5px;
}

.high-percentage {
  background-color: #a0e2b3;
  /* color: white !important; */
}

.medium-percentage {
  background-color: #f2e3b0;
  /* color: black; */
}

.low-percentage {
  background-color: #fb817e;
  /* color: white; */
}

.full-width {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  /* padding: 15px; Si quieres mantener el padding interno */
}

.el-table__cell {
  height: 20px !important;
}
</style>
    


// WEBPACK FOOTER //
// src/components/ADashboard/descargos.vue